import {API_URL} from 'api/constants'

const V1_URL = `${API_URL}/v1/users`

export const FORGOT_PASSWORD = `${V1_URL}/forgot_password`

const MOKA_SERVICE_HOST = process.env.MOKA_SERVICE_HOST

export const PERMISSION_SERVICE_V1_BY_ID = (userId) => `${MOKA_SERVICE_HOST}/account/v1/users/${userId}/permissions`



// WEBPACK FOOTER //
// ./app/api/users/constants.js